import { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
  FormGroup,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";

import * as Yup from "yup";

import DebugOutput from "../DebugOutput";
import FormHelpers from "../../helpers/FormHelpers";
import ScrollToFieldError from "./Validation/ScrollToFieldError";
import InfoTooltip from "../UI/InfoTooltip";

function RequestForm(props) {
  const isUpdating = false;

  const displayHonoree = props.donation.DisplayHonoree;
  const honoreeThresholdAmount = props.donation.HonoreeThresholdAmount;

  let prices = props.donation.DonationAmounts.split("|");
  if(displayHonoree) {
    prices = [1000.00, 500.00, 250.00, 100.00];
  }

  const validationRules = {
    amount: Yup.string().required("Please select an amount"),
    customAmount: Yup.number()
      .typeError("Please enter a donation amount of at least $1.00.")
      .when("amount", (amount) => {
        if (amount == "other")
          return Yup.number()
            .typeError("Please enter a donation amount of at least $1.00.")
            .min(1, "Please enter a donation amount of at least $1.00.")
            .required("Please enter a donation amount of at least $1.00.");
      }),
  };

  const formSchema = Yup.object().shape(validationRules);

  // submit form
  function formSubmitHandler(values) {
    FormHelpers.scrollToTop();
    props.onSubmit(values);
  }

  let donationAmount = "";
  let donationCustomAmount = "";
  let defaultPriceFound = false;

  prices.forEach((price) => {
    if(Number(price) == Number(props.donation.SKUPrice)) {
      defaultPriceFound = true;
    }
  });

  if(defaultPriceFound) {
    donationAmount = String(Number(props.donation.SKUPrice).toFixed(2));
  } else {
    if(props.donation.CartItemId) {
      donationAmount = "other";
      donationCustomAmount = props.donation.SKUPrice;
    }
  }

  return (
    <div className="cfg-input-form cfg-request" data-step="request">
      <Formik
        initialValues={{
          amount: donationAmount,
          customAmount: donationCustomAmount,
          honoree: "",
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form className="text-start">
            <ScrollToFieldError />
            <Container className="cfg-form-section">
              <Row>
                <Col xs="12">
                  {/* <InfoTooltip
                    id="intentionHelp"
                    title="Help"
                    text="The person(s) on whose behalf the Mass is to be celebrated."
                  /> */}

                  <div className="mb-3">
                    <h4 className="required">My Gift Is:</h4>

                    {prices.map((price) => (
                      <div className="form-check" key={price}>
                        <label>
                          <Field
                            type="radio"
                            name="amount"
                            value={price.toString()}
                            onChange={handleChange}
                          />
                          ${price}
                        </label>
                      </div>
                    ))}

                    <div className="form-check">
                      <label>
                        <Field
                          type="radio"
                          name="amount"
                          value="other"
                          onChange={handleChange}
                        />
                        Other
                      </label>
                    </div>

                    {errors.amount && touched.amount && (
                      <div className="invalid-feedback">{errors.amount}</div>
                    )}

                    {values.amount === "other" && (
                      <div>
                        <label>
                          $ <Field type="text" name="customAmount" />
                        </label>
                      </div>
                    )}

                    {errors.customAmount && touched.customAmount && (
                      <div className="invalid-feedback">
                        {errors.customAmount}
                      </div>
                    )}
                  </div>

                  {displayHonoree &&
                    Number(honoreeThresholdAmount) > 0 &&
                    values.amount &&
                    (Number(values.amount) >
                      Number(honoreeThresholdAmount) ||
                      (values.customAmount &&
                        Number(values.customAmount) >
                          Number(honoreeThresholdAmount))) && (
                      <div className="mb-3"></div>
                    )}
                </Col>
              </Row>
            </Container>
            <Button
              type="submit"
              size="sm"
              color="primary"
              className="float-end"
            >
              {( (props.donation.CartItemId) ? 'Update Cart' : 'Add to Cart' )}
            </Button>
            {/* <DebugOutput
              errors={errors}
              values={FormHelpers.getValues(values)}
            /> */}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default RequestForm;
